<script setup>
import { ref, onUpdated, defineProps, defineEmits } from "vue"
import useUsers from "../../use/useUsers"
import usePersianTools from "../../use/usePersianTools"

const props = defineProps({
  user: {
    required: true,
    type: Object,
  },
})

const userData = ref({
  id: props.user.id,
  password: "",
  password_confirmation: "",
})

const emit = defineEmits(["update:modelValue", "close"])

const { show, loading, errors, changePasswordUser, closeModal } =
  useUsers(props, emit, userData)

const { convertPersianToEnglish } = usePersianTools()

onUpdated(() => {
  userData.value = {
    id: props.user.id,
    password: "",
    password_confirmation: "",
  }
})
</script>

<template>
  <!-- edit user modal  -->
  <b-modal
    v-model="show"
    @close="closeModal()"
    id="showModal"
    hide-footer
    title="تغییر کلمه عبور کاربر"
    header-class="p-3 bg-light"
    class="v-modal-custom"
    centered
    no-close-on-backdrop
  >
    <b-overlay
      variant="white"
      opacity="0.75"
      blur="2px"
      :show="loading"
      spinner-variant="success"
      rounded="sm"
    >
      <b-card>
        <b-form
          id="changePasswordForm"
          class="tablelist-form"
          autocomplete="off"
          @submit.prevent="changePasswordUser"
        >
          <div class="mb-3">
            <label for="password" class="form-label">کلمه عبور</label>
            <input
              type="password"
              id="password"
              class="form-control"
              placeholder="کلمه عبور (پسورد)"
              v-model="userData.password"
              @input="
                convertPersianToEnglish(
                  $event.target.value,
                  userData,
                  'password'
                )
              "
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.password">
                <span>{{ errors.password[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="confirm-password" class="form-label"
              >تایید کلمه عبور</label
            >
            <input
              type="password"
              id="confirm-password"
              class="form-control"
              placeholder="تایید کلمه عبور (تکرار کلمه عبور)"
              v-model="userData.password_confirmation"
              @input="
                convertPersianToEnglish(
                  $event.target.value,
                  userData,
                  'password_confirmation'
                )
              "
            />
          </div>

          <div class="hstack gap-2 justify-content-end">
            <b-button
              type="button"
              id="closemodal"
              variant="light"
              @click="closeModal"
            >
              بستن
            </b-button>
            <b-button type="submit" variant="success">تغییر کلمه عبور</b-button>
          </div>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
